import instance from './axios';

export const getDashboardData = async (frequency = 'today', moduleId = null) => {
    try {
        let url = `/dashboard?frequency=${frequency}`;
        if (moduleId) url += `&moduleId=${moduleId}`;
        const result = await instance.get(url);
        return { success: true, data: result.data };
    } catch (e) {
        return { success: false, data: null, message: e.response?.data?.message };
    }
};
